// import { isNull, omitBy } from "lodash";
// import styled from "styled-components";
// import React, { useEffect, useState } from "react";
// import { useForm } from "react-hook-form";
// import { useDispatch } from "react-redux";
// import { Flex } from "../../../components/layout";
// import { UsersDTO } from "../../../store/users/models/dto";
// import {
//   useYupValidationResolver,
//   NullablePartial,
// } from "../../../utils/utils";

import { Grid } from "@material-ui/core";
import { SubscribeForm } from "./forms/SubscribeForm";
import { Widget } from "../../../components/widget";
import styled from "styled-components";

const StyledWidget = styled(Widget)`
  &:not(:last-child) {
    margin-bottom: 1em;
  }
`;
// import NowPaymentsApi from "@nowpaymentsio/nowpayments-api-js"

// import { SubscribeForm } from "./forms/SubscribeForm";

// type RequestDTO = UsersDTO.Requests.UserDetails.T;
// const { useFields, defaults } = UsersDTO.Requests.UserDetails;

// export const EditButtons = styled(Flex)`
//   justify-content: flex-end;
// `;

// export const Subscribe: React.FunctionComponent<{
// }> = ({ }) => {

//   // const country = watch("country");

//   // useEffect(() => {
//   //   const phoneValue = getValues("phone");
//   //   if (phoneValue === undefined || phoneValue === "") {
//   //     setValue("phoneCountryCode", country);
//   //   }
//   // }, [country, getValues, setValue]);

//   // useEffect(() => {
//   //   if (!editing) reset();
//   // }, [editing, reset]);

//   return (
//     <SubscribeForm onClose={() => { }} />
//   );
// };


// import { Grid } from "@material-ui/core";
// import React, { useMemo } from "react";
// import { Loader } from "../../components/loader";
// // import { NullablePartial } from "../../utils/utils";
// import { useFetchable } from "../../store/common/fetchable";
// import { UsersDTO } from "../../store/users/models/dto";
// import { Users } from "../../store/users/reducer";
// import { VerificationDTO } from "../../store/verification/models/dto/kyc";
// import { Verification } from "../../store/verification/reducer";
// import { Pageable } from "../../services/pageable";
// import { Subscribe } from "./subscribe";

// export const SubscriptionPage = () => {
//     const currentUser = useFetchable(Users.current);
//     const allSelfKyc = useFetchable(
//         Verification.allSelfKyc,
//         useMemo<Pageable.T<"userStatus" | "createdDate">>(
//             () => ({
//                 pagination: {
//                     size: 5,
//                     page: 0,
//                 },
//                 sorting: {
//                     direction: "desc",
//                     field: "createdDate",
//                 },
//             }),
//             []
//         )
//     );

//     return (
//         <Loader<
//             UsersDTO.Responses.GetSingle.T | VerificationDTO.Responses.GetAllKyc.T
//         >
//             data={[currentUser, allSelfKyc]}
//         >
//             {([loadedCurrentUser, loadedAllSelfKyc]) => (
//                 <SubscriptionForm
//                 // allSelfKyc={loadedAllSelfKyc as VerificationDTO.Responses.GetAllKyc.T}
//                 // currentUser={loadedCurrentUser as UsersDTO.Responses.GetSingle.T}
//                 />
//             )}
//         </Loader>
//     );
// };

export const SubscriptionPage: React.FunctionComponent<{
  // currentUser: NullablePartial<UsersDTO.Requests.UserDetails.T>;
  // allSelfKyc: VerificationDTO.Responses.GetAllKyc.T;
}> = ({
  //  currentUser, allSelfKyc
}) => {
    return (
      <StyledWidget title="Subscription">

        To gain access to the Sekuritance Dashboard and related functions, please confirm your subscription below. Until the end of June 2024, the yearly price is set to the equivalent of Eur 50 per year. Price might change after that date. You can pay this by either one of the currencies listed hereunder.
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <SubscribeForm onClose={() => { }} />
              </Grid>
            </Grid>
          </Grid>

        </Grid>
      </StyledWidget>
    );
  };
